import { CHANGE_GEDER } from "./constants";

export const setGender = (text) => ({
    type: CHANGE_GEDER,
    payload: text,
});
